<mat-card>
  <mat-card-title>
    Modèles des pièces jointes
  </mat-card-title>
  <mat-card-content>
    <input type="file" [accept]="requiredFileType" (change)="onFileSelected($event)" #fileUpload [hidden]="true">
    <div fxLayout="column" *ngIf="!downloadOnly">
      <div fxLayoutAlign="end">
        <mat-card-actions align="end">
          <button mat-raised-button (click)="addModel()" routerLinkActive="true"
                  aria-disabled="false" color="accent"
                  matTooltipPosition="right" matTooltip="Ajouter un nouveau modèle">
            <i class="fa fa-plus"></i> Nouveau
          </button>
        </mat-card-actions>
      </div>
    </div>
    <ng-container *ngIf="!hasFiles">
      <mark>Aucun modèle de pièces à joindre de disponible.</mark>
    </ng-container>
    <app-data-table
                  [dataSource]="pjTemplateFileSource"
                  [extraParams]="extraParams"
                  [columns]="columns"
                  [actions]="actions"
                  [pageSize]="5" [pageSizesList]="[5,10,25]"
                  [filterDisplay]="false"
                  [showLoader]="true"
                  [refreshIcone]="false"
                  [loaderMask]="false">
    </app-data-table>
  </mat-card-content>
</mat-card>
